module.exports = __webpack_public_path__ + "static/media/Weathervane-masterdeed.c52c8db4.pdf";